import styled from 'styled-components';

const SpanCircle = styled.div`
  display: flex;
  align-items: center;
`;

export default SpanCircle;
